import { useEffect, useState } from "react";
import { usePapaParse } from "react-papaparse";
import { Chart, Axis, Tooltip, Coord, Legend, Interval } from "bizcharts";
import DataSet from "@antv/data-set";
import { Box } from "@mui/system";

import DownloadButton from "../Common/DownloadButton";

const HorizontalBarChartWithNegative = (props) => {

    const [data, setData] = useState(undefined);

    const csv = props.csv;
    const { readString } = usePapaParse();

    const handleReadString = () => {
        readString(csv, {
            complete: (results, file) => {
                setData(results.data.sort((a, b) => (a[props.retained] < b[props.retained]) ? 1 : -1))
            },
            download: true,
            header: true,
            dynamicTyping: true,
            error: (error, file) => {
                console.log('Error while parsing:', error, file);
            },
        });
    };

    useEffect(() => {
        handleReadString();
    }, [csv]);
    const { DataView } = DataSet;
    const dv = new DataView();

    const transformedFields = props.fields.length === 1 ? [props.fields[0]] : [props.fields[0], props.fields[1], props.fields[2]];
    if (data) {
        dv.source(data)
            .transform({
                type: "fold",
                fields: transformedFields,
                key: "result",
                value: "value",
                retains: [props.retained]
            });
    }


    const styles = {
        mainTitle: {
            fontSize: 20,
            color: "black",
            textAlign: "center"
        }
    }
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);
    useEffect(() => {
        function handleResize() {
            setIsMobile(window.innerWidth <= 900)
        }
        window.addEventListener('resize', handleResize)
        return _ => {
            window.removeEventListener('resize', handleResize)
        }
    })

    const scale = (props.fields.length === 1) ? {} : { value: { min: 0, max: 100 } };
    return (
        <Box sx={{ width: '100%' }}>
            {props.fields.length === 1 && <DownloadButton imageAsset={props.chartImg} fileName={props.title} csv={data} isRaw />}
            {props.fields.length > 1 && !isMobile && < p style={{ fontFamily: 'Roboto Condensed, sans-serif', marginBottom: '.75rem' }}>{props.title}</p>}
            {props.fields.length === 1 && isMobile && < p style={{ fontFamily: 'Roboto Condensed, sans-serif', marginBottom: '.8rem' }}>{props.title}</p>}

            <Chart
                height={props.fields.length === 1 && isMobile ? 100 : props.small ? 350 : 450}
                padding={props.fields.length === 1 && isMobile ? [0, 0, 30, 30] : 'auto'}
                data={dv}
                autoFit
                scale={scale}
                onGetG2Instance={c => {
                    if (props.fields.length === 1) {
                        c.removeInteraction('legend-filter');
                    }
                }}
            >
                {props.fields.length === 1 && <Axis name={props.retained} label={false} title={null} labelOffset={10} />}
                {props.fields.length > 1 && <Axis
                    name={props.retained}
                    title={null}
                    labelOffset={10}
                    label={{
                        style: {
                            fontFamily: 'Roboto Condensed, sans-serif',
                        }
                    }}
                />}
                <Axis
                    name="value"
                    label={{
                        formatter: (val) => {
                            return val + "%";
                        },
                        style: {
                            fontFamily: 'Roboto Condensed, sans-serif'
                        }
                    }}
                    position="left"
                />
                {props.fields.length !== 1 && !isMobile &&
                    <Axis name={props.retained} />
                }
                {props.fields.length !== 1 && isMobile &&
                    <Axis name={props.retained} verticalFactor={-1}
                        label={{
                            autoHide: false,
                            rotate: 200,
                            offset: 10,
                            style: {
                                textAlign: 'end',
                                fill: '#404040',
                                fontSize: 12,
                                textBaseline: 'top'
                            },
                        }} />
                }
                <Coord transpose={!isMobile} />
                <Tooltip shared itemTpl={'<li style="padding: 10px 0" data-index={index}>'
                    + '<span style="background-color:{color};width:8px;height:8px;border-radius:50%;display:inline-block;margin-right:8px;"></span>'
                    + '{name}: {value}%'
                    + '</li>'} />
                <Interval
                    size={10}
                    position={`${props.retained}*value`}
                    color={[
                        "result",
                        function (result) {
                            return props.colorMap[result];
                        }
                    ]}
                    shape="smooth"
                    opacity={0.8}
                    label={false}
                    adjust={{
                        type: 'stack'
                    }}
                />
                <Legend flipPage={false} />

            </Chart>
        </Box >

    );

}

export default HorizontalBarChartWithNegative;